import { RelationType } from '@thro-types/access-handler';

import { pick } from 'lodash';
import * as yup from 'yup';

export const entitlementGroupValidation = t =>
  yup.object().shape({
    name: yup.string(),
    relationType: yup.string().oneOf(Object.keys(RelationType)),
    faculty: yup.number().when(['relationType'], {
      is: relationType => relationType === 'FACULTY',
      then: yup.number().required(),
      otherwise: yup.number().nullable()
    }),
    course: yup.number().when(['relationType'], {
      is: relationType => relationType === 'COURSE',
      then: yup.number().required(),
      otherwise: yup.number().nullable()
    }),
    entitlements: yup.array(yup.number()).min(1).required()
  });

export const useEntitlementGroupInitialValues = props => {
  const values = props.entitlementGroup
    ? {
        ...pick(props.entitlementGroup, ['id', 'name', 'relationType', 'faculty', 'course']),
        entitlements: props.entitlementGroup.entitlements.map(ent => ent.id)
      }
    : { name: '', relationType: '', faculty: null, course: null, entitlements: [] };
  return values;
};
